import * as yup from 'yup'
export const editPaymentMethodSchema = yup.object().shape({
    name: yup.string().required('من فضلك ادخل اسم الطريقة التى تريد اضافتها '),
    is_disabled: yup.boolean(),
})
